/**
 * Single Product Thumbnail Template
 */

export const productThumbnail = post => {
	const wrapper = document.getElementById('load-more-container');
	const el = wrapper.firstElementChild;

	// Image Sizes
	let sizes = post._embedded['wp:featuredmedia'][0].media_details.sizes,
		productThumbnail = sizes.product_thumbnail.source_url,
		full = sizes.full.source_url,
		large = sizes.large.source_url,
		mediumLarge = sizes.medium_large.source_url,
		medium = sizes.medium.source_url;

	let newEl = el.cloneNode(true);
	let img = newEl.querySelector('img');
	let title = newEl.querySelector('.title');

	img.src = productThumbnail;
	img.srcset = `${full} 1040w, ${medium} 300w, ${large} 1024w, ${mediumLarge} 768w, ${productThumbnail} 540w`;
	img.alt = post.title.rendered;
	title.innerHTML = post.title.rendered;
	return newEl;
};



// WEBPACK FOOTER //
// ./scripts/templates/single-product-thumbnail.js